import { useSortable } from "@dnd-kit/sortable";
import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
import {
  DragIndicator as DragIndicatorIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import { CSS } from "@dnd-kit/utilities";

const SortableQuestion = ({ item, handleOpenModal, reordering }) => {
  const theme = useTheme();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item?.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      sx={{
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
        py: 1.5,
        backgroundColor:
          theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.05)"
            : "#f9fafb",
        borderRadius: 3,
        border: `1.5px solid ${theme.palette.divider}`,
        boxShadow:
          theme.palette.mode === "dark"
            ? "0px 2px 6px rgba(0, 0, 0, 0.3)"
            : "0px 2px 6px rgba(0, 0, 0, 0.05)",
        "&:hover": {
          bgcolor:
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.08)"
              : "#f9fafb",
        },
        mb: 1,
        p: 1,
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{ width: "100%" }}
      >
        <IconButton
          size="small"
          {...attributes}
          {...listeners}
          sx={{
            color: theme.palette.text.secondary,
            cursor: "grab",
            "&:active": {
              cursor: "grabbing",
            },
          }}
          disabled={reordering}
        >
          <DragIndicatorIcon />
        </IconButton>

        <Box sx={{ flex: 1 }}>
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.primary,
              fontWeight: 400,
              lineHeight: 1,
            }}
          >
            {item?.questionText}
          </Typography>
        </Box>

        {/* <IconButton
          size="small"
          disabled={true}
          onClick={() => handleOpenModal(item)}
          sx={{
            color: theme.palette.primary.main,
          }}
        >
          <EditIcon fontSize="small" />
        </IconButton> */}
      </Stack>
    </Box>
  );
};

export default SortableQuestion;
